import { render, staticRenderFns } from "./flight-pad.vue?vue&type=template&id=67201263"
import script from "./flight-pad.vue?vue&type=script&lang=js"
export * from "./flight-pad.vue?vue&type=script&lang=js"
import style0 from "./flight-pad.vue?vue&type=style&index=0&id=67201263&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports